// **** import modules ****
import app, { csl } from "@@assets/scripts/common";
import $ from "jquery";

// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	const showModal = location.search;
	csl.log("showModal", showModal);
	if( showModal.indexOf("yt=0") >= 0 ) {
		return;
	}

	$.ajax({
		url: 'https://www.youtube.com/iframe_api',
		async: false,
		dataType: "script",
		success: function () {
			loadVideo();
		}
	});
	
	let player;
	const loadVideo = () => {
		window.YT.ready( () => {
			player = new window.YT.Player("ytplayer", {
				height: "390",
				width: "640",
				videoId: "W97w8zEvLJg",
				playerVars: {
					rel: 0
				},
			});
		});
	}

	$("body").addClass("is-show-modal");
	$(".close-modal").on("click", () => {
		$("#modal_movie").addClass("hidden");
		$("body").removeClass("is-show-modal");
		player.stopVideo();
	});
});

app.exec();
